import {combineReducers} from 'redux';
import ResumeList from './resumeList';

export const resumeReducer = combineReducers({
  ResumeList,
});
